import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import Signin from '../components/SignIn/Signin'

const Login = () => {
  return (
    <div>
        <Navbar/>
        <Signin/>
        <Footer/>
    </div>
  )
}

export default Login